import { SingleVisitPat } from '../../../../../images';

export default function SingleVisit() {
  
  return (
    <div className="relative h-screen ">
      <div className="h-1/2 lg:h-full w-full pt-16 md:pt-20 lg:pt-0 flex flex-col justify-center text-center  lg:w-1/2 lg:text-left ">
        <div className="z-10 px-4 max-w-2xl mx-auto sm:px-8">
          <h1 className="text-center lg:text-left text-primary text-2xl sm:text-3xl lg:text-4xl font-semibold">
            Single Visit Dentistry by XiViX
          </h1>
          <p className="mt-3 text-lg text-gray-500 sm:text-xl md:mt-5 md:max-w-3xl">
            <h2 className="text-center lg:text-left text-xl font-sans text-lpGray my-2">
              Simple Prep & Place*
            </h2>
            <div className="my-2 mx-auto lg:mx-0 lg:my-4 w-32 border border-primary" />
            <ul>
              <li className="my-1 text-base lg:text-lg">
                <span className="lg:text-base font-extrabold mr-1 text-primary">
                  &#x2022;
                </span>
                optimized AI prep-assistance
              </li>
              <li className="my-1 text-base lg:text-lg">
                <span className="lg:text-base font-extrabold mr-1 text-primary">
                  &#x2022;
                </span>
                no messy impressions
              </li>
              <li className="my-1 text-base lg:text-lg">
                <span className="lg:text-base font-extrabold mr-1 text-primary">
                  &#x2022;
                </span>
                no metal fillings
              </li>
              <li className="my-1 text-base lg:text-lg">
                <span className="lg:text-base font-extrabold mr-1 text-primary">
                  &#x2022;
                </span>
                no temporaries
              </li>
              <li className="my-1 text-base lg:text-lg">
                <span className="lg:text-base font-extrabold mr-1 text-primary">
                  &#x2022;
                </span>
                optimized fit
              </li>
              <li className="my-1 text-base lg:text-lg">
                <span className="lg:text-base font-extrabold mr-1 text-primary">
                  &#x2022;
                </span>
                long lasting restorations
              </li>
            </ul>
            <p className="my-4 text-sm">
              *For inlays, overlays, crowns and veneers.
            </p>
          </p>
        </div>
      </div>
      <div className="relative w-full h-1/2 top-0 lg:absolute lg:inset-y-0 lg:right-0 lg:w-1/2 lg:h-full z-0">
        <img
          className="absolute inset-0 top-0 w-full h-full object-contain"
          src={SingleVisitPat}
          alt=""
        />
      </div>
    </div>
  );
}
